import type { CollectionRecord, CollectionItemRecord, CollectionItem } from './types';

export function adaptCollectionRecord(raw: unknown): CollectionRecord {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<CollectionRecord>;
  return {
    id: String(data.id || ''),
    tenant_id: String(data.tenant_id || ''),
    site_id: String(data.site_id || ''),
    name: String(data.name || 'Untitled Collection'),
    slug: String(data.slug || ''),
    schema_json: data.schema_json && typeof data.schema_json === 'object' ? data.schema_json : {},
    created_at: String(data.created_at || ''),
  };
}

export function adaptCollectionRecordList(raw: unknown): CollectionRecord[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(adaptCollectionRecord);
}

export function adaptCollectionItemRecord(raw: unknown): CollectionItemRecord {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<CollectionItemRecord>;
  return {
    id: String(data.id || ''),
    tenant_id: String(data.tenant_id || ''),
    collection_id: String(data.collection_id || ''),
    item_slug: String(data.item_slug || ''),
    fields_json: data.fields_json && typeof data.fields_json === 'object' ? data.fields_json : {},
    status: String(data.status || 'draft'),
    created_at: String(data.created_at || ''),
    updated_at: String(data.updated_at || ''),
  };
}

export function adaptCollectionItemRecordList(raw: unknown): CollectionItemRecord[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(adaptCollectionItemRecord);
}

export function adaptCollectionItem(rec: CollectionItemRecord): CollectionItem {
  return {
    id: rec.id,
    item_slug: rec.item_slug,
    status: rec.status === 'published' ? 'published' : 'draft',
    fields: rec.fields_json,
    updated_at: rec.updated_at,
  };
}

export function adaptCollectionItemList(raw: unknown): CollectionItem[] {
  return adaptCollectionItemRecordList(raw).map(adaptCollectionItem);
}
